module.exports = __webpack_public_path__ + "img/mobilehardware7.2f3ecead.png";